// extracted by mini-css-extract-plugin
module.exports = {"giftBlockWrapper":"GiftBlock_giftBlockWrapper__v_A9A"};